<script>
	// @ts-nocheck

	import { CodeEditor } from '@shopboxai/sb-portal-components';

	import { userid } from '../utils';
	import { getConfig, saveConfig, getConfigHistory } from '../configUtils';
	const urlParams = new URLSearchParams(window.location.search);
	const client = urlParams.get('client');
	const configType = urlParams.get('config_type');
	const configLabel = urlParams.get('config_label');
	const sourceConfigType = urlParams.get('source_config_type');
	let config;
	let getConfigLocal = async (fname) => {
		config = await getConfig($userid, client, configType, configLabel, fname, sourceConfigType);
	};

	/**
	 * @param {{ target: { value: any; }; }} e
	 */
	async function refetchConfig(e) {
		console.log(e.target.value);
		await getConfigLocal(e.target.value);
	}
	async function save() {
		let res = await saveConfig($userid, client, configType, configLabel, config, sourceConfigType);

		config = res.config;
		alert(res.detail);
	}
</script>

{#await getConfigHistory($userid, client, configType, configLabel) then history}
	<select name="" id="" on:change={refetchConfig}>
		{#each history as hc}
			<option value={hc.name}>{hc.name}, {hc.config_label}, {hc.created_at}</option>
		{/each}
	</select>
{:catch error}
	<p class="error">
		{error}
	</p>
{/await}
{#await getConfigLocal() then}
	<button on:click={save}>Save</button>
	<CodeEditor bind:origin={config} value={JSON.stringify(config, null, 2)} />
{:catch error}
	failed fetching config {error}
{/await}

<style>
	select {
		border: 1px solid #000;
	}
	button {
		background-color: #bafca2;
		border: 1px solid #000;

		padding: 0.7em;
		border-radius: 8px;
	}
	.error {
		display: inline;
		border: 1px solid #000;
		border-radius: 8px;
		padding: 0.7em;
		background-color: #ff6b6b;
		color: #000;
		font-size: 14px;
		margin-bottom: 6px;
	}
</style>
